import { TenantVertical } from "@sp-crm/core";

export const verticalLabels: Record<TenantVertical, string> = {
    placement: "Placement",
    homeCare: "Home care",
};

export const knownVerticals = (verticals: string[]): TenantVertical[] =>
    verticals.filter(
        (vertical): vertical is TenantVertical => vertical in verticalLabels,
    );
